"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = void 0;
exports.reducer = reducer;
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
exports.initialState = {
    openedPath: [],
    showProfileResetConfirmation: false
};
function reducer(state = exports.initialState, action) {
    switch (action.type) {
        case "main-menu/CLOSE_MENU":
            return Object.assign(Object.assign({}, state), { openedPath: [] });
        case "main-menu/OPEN_ROOT_NAV_ITEM":
            return Object.assign(Object.assign({}, state), { openedPath: [action.payload] });
        case "main-menu/OPEN_SUB_NAV_ITEM":
            return Object.assign(Object.assign({}, state), { openedPath: [state.openedPath[0], action.payload] });
        case "main-menu/CLOSE_SUB_NAV_ITEM":
            return Object.assign(Object.assign({}, state), { openedPath: [state.openedPath[0]] });
        case "main-menu/TOGGLE_PROFILE_RESET_CONFIRMATION_ON":
            return Object.assign(Object.assign({}, state), { openedPath: [], showProfileResetConfirmation: true });
        case "main-menu/TOGGLE_PROFILE_RESET_CONFIRMATION_OFF":
            return Object.assign(Object.assign({}, state), { showProfileResetConfirmation: false });
        case "global-actions/REQUEST_OPEN_TAB":
        case "global-actions/RESET_USER_SETTINGS_REQUESTED":
        case "global-actions/SCREEN_AMOUNT_PROFILE_SELECTED":
        case "global-actions/LANGUAGE_SELECTED":
            return state;
        default:
            (0, ts_exhaustive_check_1.exhaustiveCheck)(action);
            return state;
    }
}
//# sourceMappingURL=reducer.js.map